import React, { useRef, useState } from "react";
import { Typography } from "@material-ui/core";
import { Pacient } from "app/models/pacient";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { Spinner } from "react-bootstrap";
import ClearIcon from "@material-ui/icons/Clear";

interface PatientGeneralCardViewProps {
  patient: Pacient;
  loading?: boolean;
  onUpdatePhoto?: (patientId: string, photo: File) => void;
  onDeletePhoto?: (patientId: string) => void;
}

function PatientGeneralCardView({
  patient,
  loading = false,
  onUpdatePhoto,
  onDeletePhoto,
}: PatientGeneralCardViewProps & WrappedComponentProps) {
  const birthDate = patient.birthday
    ? new Date(
        patient.birthday
          .split("/")
          .reverse()
          .join("/")
      )
    : null;

  const age = birthDate
    ? Math.floor(
        (new Date().getTime() - birthDate.getTime()) /
          (1000 * 3600 * 24 * 365.25)
      )
    : null;

  const sex =
    patient.sex === "male"
      ? "Masculino"
      : patient.sex === "female"
      ? "Feminino"
      : "Outro";

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [isHovered, setIsHovered] = useState(false);

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handlePhotoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0] && onUpdatePhoto) {
      const selectedFile = event.target.files[0];
      onUpdatePhoto(patient.id, selectedFile);
    }
  };

  const handleDeletePhoto = () => {
    if (onDeletePhoto) {
      onDeletePhoto(patient.id);
    }
  };

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            color: "#007896",
          }}
        >
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <Typography variant="h5" style={{ marginTop: 10, color: "#007896" }}>
            {patient.name}
          </Typography>
          <Typography variant="body1" style={{ color: "#948d8d" }}>
            Dados Pessoais
          </Typography>
          <Typography variant="body1" style={{ marginTop: 15 }}>
            Prontuário Médico:{" "}
            <strong>{patient.medicalRecord || "Não Informado"}</strong>
          </Typography>
          <Typography variant="body1" style={{ marginTop: 15, width: "60%" }}>
            Idade: <strong>{age ? `${age} anos` : "Não Informado"}</strong>
          </Typography>
          <Typography variant="body1" style={{ width: "60%" }}>
            Sexo: <strong>{sex}</strong>
          </Typography>
          <Typography variant="body1" style={{ width: "60%" }}>
            Tipo Sanguíneo:{" "}
            <strong>{patient.bloodType || "Não Informado"}</strong>
          </Typography>
          <div
            style={{
              position: "absolute",
              bottom: -65,
              right: -130,
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: 150,
                height: 150,
                cursor: "pointer",
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img
                src={patient.photoUrl || "/media/users/blank.png"}
                alt="Foto de Perfil"
                style={{
                  borderRadius: "50%",
                  border: "6px solid #007896",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#fff",
                  width: "100%",
                  height: "100%",
                }}
                onClick={triggerFileInput}
              />
              {isHovered && (
                <>
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#fff",
                      fontSize: "14px",
                      fontWeight: "bold",
                      zIndex: 1,
                    }}
                    onClick={triggerFileInput}
                  >
                    Atualizar Foto
                  </div>
                  {patient.photoUrl && (
                    <button
                      title="Remover Foto"
                      onClick={handleDeletePhoto}
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        backgroundColor: "#ff4d4f",
                        color: "#fff",
                        border: "none",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        zIndex: 2,
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      <ClearIcon style={{ fontSize: 20 }} />
                    </button>
                  )}
                </>
              )}
            </div>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handlePhotoChange}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default injectIntl(PatientGeneralCardView);
